// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__g6e8v","description__title":"styles_description__title__3nNk2"};